<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="门店图片" min-width="110" align="center">
				  <template slot-scope="scope">
					<img :src="scope.row.avatar" style="width: 50px;height: 50px;" @click="viewImage(scope.row,'avatar')" v-if="scope.row.avatar">
					<img src="@/assets/images/empty.png" style="width: 50px;height: 50px;" v-else>
				  </template>
				</el-table-column>
				<el-table-column label="门店名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="类型" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.store_type_name }}
				  </template>
				</el-table-column>
				<el-table-column label="管理人" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.username }}
				  </template>
				</el-table-column>
				<el-table-column label="电话" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.mobile }}
				  </template>
				</el-table-column>
				<el-table-column label="余额" min-width="110" align="center" prop="balance">
					<template slot-scope="scope">
					  <a @click="recordQuery('balance', scope.row.id)" style="color: #2d8cf0;cursor: pointer;">{{ scope.row.balance || '0.00'}}</a>
				    </template>
				</el-table-column>
				<el-table-column label="地址" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.address }}
				  </template>
				</el-table-column>
				<el-table-column label="分红类型" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.fh_type_name }}
				  </template>
				</el-table-column>
		<!-- 		<el-table-column label="分红比例" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.fh_scale || '0'}}%
				  </template>
				</el-table-column> -->
				<el-table-column label="推荐" min-width="60" align="center">
					<template slot-scope="scope">
						<el-switch
						 v-model="scope.row.is_rec"
						 @change="changeStatus(scope.row,'is_rec')"
						 active-color="#13ce66"
						 :active-value="1"
						 :inactive-value="2">
						 </el-switch>
					</template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
					<el-tag v-if="scope.row.status === 3" size="mini" type="warning">待审核</el-tag>
					<el-tag v-if="scope.row.status === 4" size="mini" type="danger">驳回</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="200" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="查看" placement="top">
					  <el-button type="success" icon="el-icon-view" size="mini" circle @click="handleView(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="分红设置" placement="top" v-if="scope.row.status == 1 && scope.row.fh_type == 1">
					  <el-button type="warning" icon="el-icon-setting" size="mini" circle @click="handleOperate1(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="分红设置" placement="top" v-if="scope.row.status == 1 && scope.row.fh_type == 2">
					  <el-button type="warning" icon="el-icon-setting" size="mini" circle @click="handleOperate2(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="待审核" placement="top" v-if="scope.row.status == 3">
					  <el-button type="warning" icon="el-icon-circle-check" size="mini" circle @click="handleOperate(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="余额" placement="top">
						<el-button type="warning" icon="el-icon-help" size="mini" circle
							@click.stop="handleBalance(scope.row)"></el-button>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="warning" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="800px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
			<el-row>
				<el-col :span="12">
					<el-form-item label="门店名称" prop="name">
					  <el-input v-model="form.name" placeholder="请输入门店名称" type="text" clearable />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="联系人" prop="username">
					  <el-input v-model="form.username" placeholder="请输入管理人" type="text" clearable />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="电话" prop="mobile">
					  <el-input v-model="form.mobile" placeholder="请输入电话" type="text" clearable />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份证号" prop="id_card">
					  <el-input v-model="form.id_card" placeholder="请输入身份证号" type="text" clearable />
					</el-form-item>
				</el-col>
			</el-row>
		    <el-row>
		    	<el-col :span="12">
		    		<el-form-item label="区域" prop="area_id">
		    		  <el-cascader
					    class="w-100"
		    			size="large"
		    			:options="options"
		    			v-model="selectedOptions"
		    			@change="handleChange">
		    		  </el-cascader>
		    		</el-form-item>
		    	</el-col>
		    	<el-col :span="12">
		    		<el-form-item label="经纬度" prop="coordinate">
		    		  <el-input v-model="form.coordinate" placeholder="请选择经纬度" size="medium" @focus="mapVisible=true" />
		    		</el-form-item>
		    	</el-col>
		    </el-row>
		    <el-row>
		    	<el-col :span="12">
		    		<el-form-item label="地址" prop="address">
		    		  <el-input v-model="form.address" placeholder="请输入地址" type="text" clearable />
		    		</el-form-item>
		    	</el-col>
		    	<el-col :span="12">
		    		<el-form-item label="商户类型" prop="store_type">
		    			<el-select v-model="form.store_type" placeholder="请选择商户类型" size="medium" class="w-100">
		    				<el-option label="无" :value="0"></el-option>
		    				<el-option v-for="(item,index) in store_types" :key="index"
		    					:label="item.name" 
		    					:value="item.id">
		    				</el-option>
		    			</el-select>
		    		</el-form-item>
		    	</el-col>
		    </el-row>
		    <el-row>
		    	<el-col :span="12">
		    		<el-form-item label="入驻类型" prop="rz_type">
		    			<el-select v-model="form.rz_type" placeholder="请选择入驻类型" size="medium" class="w-100">
		    				<el-option label="无" :value="0"></el-option>
		    				<el-option v-for="(item,index) in rz_types" :key="index"
		    					:label="item.name" 
		    					:value="item.id">
		    				</el-option>
		    			</el-select>
		    		</el-form-item>
		    	</el-col>
		    	<el-col :span="12">
		    		<el-form-item label="分红类型" prop="fh_type">
		    			<el-select v-model="form.fh_type" placeholder="请选择分红类型" size="medium" class="w-100">
		    				<el-option label="无" :value="0"></el-option>
		    				<el-option v-for="(item,index) in fh_types" :key="index"
		    					:label="item.name" 
		    					:value="item.id">
		    				</el-option>
		    			</el-select>
		    		</el-form-item>
		    	</el-col>
		    </el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="门店照片" prop="avatar">
					  <el-upload
						class="upload-border"
						action="/manage/images/upload"
						:show-file-list="false"
						:on-success="uploadSuccess">
						<img v-if="form.avatar" :src="form.avatar" class="w-100 h-100">
						<i v-else class="el-icon-plus uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="营业执照" prop="yyzz">
					  <el-upload
						class="upload-border"
						action="/manage/images/upload"
						:show-file-list="false"
						:on-success="uploadSuccess1">
						<img v-if="form.yyzz" :src="form.yyzz" class="w-100 h-100" style="max-height: 100px;">
						<i v-else class="el-icon-plus uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="身份证正面" prop="avatar">
					  <el-upload
						class="upload-border"
						action="/manage/images/upload"
						:show-file-list="false"
						:on-success="uploadSuccess2">
						<img v-if="form.sfz_zm" :src="form.sfz_zm" class="w-100 h-100">
						<i v-else class="el-icon-plus uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="身份证反面" prop="avatar">
					  <el-upload
						class="upload-border"
						action="/manage/images/upload"
						:show-file-list="false"
						:on-success="uploadSuccess3">
						<img v-if="form.sfz_fm" :src="form.sfz_fm" class="w-100 h-100">
						<i v-else class="el-icon-plus uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="排序" prop="sort">
					  <el-input v-model="form.sort" placeholder="请输入排序" type="text" clearable />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item  label="状态">
					   <el-radio-group v-model="form.status">
					   	<el-radio :label="1" v-if="form.status == 1 || form.status == 2">使用</el-radio>
					   	<el-radio :label="2" v-if="form.status == 1 || form.status == 2">停用</el-radio>
						<el-radio :label="3" v-if="form.status != 1 && form.status != 2">待审核</el-radio>
						<el-radio :label="4" v-if="form.status != 1 && form.status != 2">驳回</el-radio>
					   </el-radio-group>
					 </el-form-item>
				</el-col>
			</el-row>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
		<tmap
		  v-if="mapVisible"
		  ref="MapWin"
		  :map-position="mapPosition"
		  @closeMapWin="mapVisible = false"
		  @setMap="setMap"
		/>
		<!-- 弹框 -->
		<el-dialog :visible.sync="operate" width="50%" :close-on-click-modal="false" append-to-body :title="title">
			<el-form ref="operate_form" :model="operate_form" label-width="120px">
				<el-form-item>
					<el-radio-group v-model="operate_form.status" size="medium">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="4">驳回</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="mini" @click="operate = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="operateSubmit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 分红模式一 -->
		<el-dialog :visible.sync="operate1" width="600px" :close-on-click-modal="false" append-to-body :title="title">
			<el-form ref="operate1_form" :model="operate1_form" :rules="rules1" label-width="80px">
				<el-form-item label="分红比例" prop="fh_scale" class="w-100">
					<div class="w-100 flex align-center">
						<el-input v-model="operate1_form.fh_scale" type="number" placeholder="请输入模式一分红比例" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="mini" @click="operate1 = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="operate1Submit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 分红模式二 -->
		<el-dialog :visible.sync="operate2" width="600px" :close-on-click-modal="false" append-to-body :title="title">
			<el-form ref="operate2_form" :model="operate2_form" :rules="rules2" label-width="80px">
				<el-form-item label="累计金额" prop="lj_money" class="w-100">
					<div class="w-100 flex align-center">
						<el-input v-model="operate2_form.lj_money" type="number" placeholder="请输入模式二累计金额" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">元</span>
					</div>
				</el-form-item>
				<el-form-item label="分红天数" prop="day" class="w-100">
					<div class="w-100 flex align-center">
						<el-input v-model="operate2_form.day" type="number" placeholder="请输入模式二分红天数" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">天</span>
					</div>
				</el-form-item>
				<el-form-item label="分红比例" prop="two_scale" class="w-100">
					<div class="w-100 flex align-center">
						<el-input v-model="operate2_form.two_scale" type="number" placeholder="请输入模式二分红比例" size="small" clearable class="flex-1"></el-input>
						<span class="ml-2">%</span>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="mini" @click="operate2 = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="operate2Submit">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 日志列表 -->
		 <el-dialog
			 :visible.sync="record_open"
			 width="1000px"
			 :close-on-click-modal="false"
			 append-to-body
			 title="日志"
		   >
			 <el-table
			   v-loading="listLoading"
			   size="small"
			   :data="recordList"
			   element-loading-text="Loading"
			   highlight-current-row
			   style="width: 100%"
			 >
			   <el-table-column label="ID" width="80" align="center">
				 <template slot-scope="scope">
				   {{ scope.row.id }}
				 </template>
			   </el-table-column>
			   <el-table-column label="描述" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.memo }}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="变更数量" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.money || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="余额" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.balance || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="资源id" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.source_id || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column align="center" label="变更时间">
				 <template slot-scope="scope">
				   <span>{{ scope.row.ctime }}</span>
				 </template>
			   </el-table-column>
			 </el-table>
			 <pagination
			   :total="recordForm.total"
			   auto-scroll
			   :page.sync="recordForm.page"
			   :limit.sync="recordForm.limit"
			   @pagination="recordQuery"
			 />
			 <div slot="footer" class="dialog-footer"></div>
		</el-dialog>
		<!-- 修改余额 -->
		<el-dialog :visible.sync="openBalance" width="600px" :close-on-click-modal="false" append-to-body :title="title">
			 <el-form ref="balanceform" :model="balanceform" :rules="balanceRules" label-width="80px" size="small">
			   <el-form-item label="当前余额" prop="balance">
				   <template>
					 {{balanceform.balance || 0}}
				   </template>
			   </el-form-item>
			   <el-form-item label="积分余额" prop="value">
				   <el-input v-model="balanceform.value" placeholder="请输入余额" type="number" clearable />
				   <small class="text-danger">正数为加，负数为减</small>
			   </el-form-item>
			   <el-form-item label="变动说明" prop="desc">
				   <el-input v-model="balanceform.desc" placeholder="请输入变动说明" type="text" clearable />
			   </el-form-item>
			 </el-form>
			 <div slot="footer" class="dialog-footer">
			   <el-button size="mini" @click="cancelBalance">取 消</el-button>
			   <el-button type="primary" size="mini" @click="handleBalanceSubmit">确 定</el-button>
			 </div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
	import tmap from '@/components/common/t_map.vue'
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
			tmap
		},
		data() {
			return {
				preUrl: 'store',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					name:'',
					username:'',
					id_card:'',
					mobile:'',
					address:'',
					sort:100,
					status:1,
					avatar:'',
					url:'',
					area_id:'',
					province:"",
					city:"",
					country:"",
					coordinate:'',
					store_type:'',
					rz_type:'',
					fh_type:'',
					sfz_zm:'',
					sfz_fm:'',
					yyzz:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					mobile: [
					  { required: true, message: '请输入电话', trigger: 'blur' }
					],
					name: [
					  { required: true, message: '请输入门店名称', trigger: ['blur', 'change'] }
					],
					area_id: [
					  { required: true, message: '请输入门店名称', trigger: ['blur', 'change'] }
					],
					address: [
					  { required: true, message: '请输入详细地址', trigger: ['blur', 'change'] }
					],
					store_type: [
					  { required: true, message: '请选择门店类型', trigger: ['blur', 'change'] }
					],
					rz_type: [
					  { required: true, message: '请选择入驻类型', trigger: ['blur', 'change'] }
					],
					fh_type: [
					  { required: true, message: '请选择分红类型', trigger: ['blur', 'change'] }
					],
				},
				province:"",
				city:"",
				country:"",
				selectedOptions: [],
				options: regionData,
				mapVisible: false,
				mapPosition: null,
				store_types:[],
				rz_types:[
					{id:1,name:'线上'},
					{id:2,name:'线下'},
				],
				fh_types:[],
				operate:false,
				operate_form:{
					id:'',
					status:'',
				},
				operate1:false,
				operate1_form:{
					id:'',
					fh_scale:'',
				},
				rules1:{
					fh_scale: [
					  { required: true, message: '请输入分红金额', trigger: 'blur' }
					],
				},
				operate2:false,
				operate2_form:{
					id:'',
					day:'',
					lj_money:'',
					two_scale:'',
				},
				rules2:{
					day: [
					  { required: true, message: '请输入分红天数', trigger: 'blur' }
					],
					lj_money: [
					  { required: true, message: '请输入累计金额', trigger: 'blur' }
					],
					two_scale: [
					  { required: true, message: '请输入分红比例', trigger: 'blur' }
					],
				},
				record_open:false,
				recordList:[],
				listLoading: false,
				recordForm: {
					page: 1,
					limit: 10,
					total:0,
					name:'',
					id:'',
				},
				openBalance:false,
				balanceform:{
					id:'',
					balance:0,
					value:'',
					desc:'',
				},
				balanceRules:{
					value: [
					  { required: true, message: '请输入值', trigger: 'blur' }
					],
				},
			}
		},
		mounted() {
			this.getStoreTypes()
			this.getFhTypes()
		},
		methods:{
			handleBalance(item){
				this.balanceform = {
					id:'',
					balance:item.balance,
					value:'',
					desc:'',
				}
				this.title = '修改积分'
				this.balanceform.id = item.id
				this.openBalance = true
			},
			cancelBalance(){
				this.openBalance = false
				this.title = ''
			},
			handleBalanceSubmit(){
				this.$refs.balanceform.validate(valid => {
				   if (valid) {
					    this.axios.post('/manage/store/edit_balance',this.balanceform).then(res=>{
						  if(res.status){
							this.$message.success('修改成功')
							this.openBalance = false
							this.title = ''
							this.getList()
						  }else{
							this.$message.error(res.msg)
						  }
						})
				   }
				})
			},
			recordQuery(name,id){
				 this.record_open = true;
				 this.recordList = [];
				 if(id){
				   this.recordForm.id = id
				 }
				 if(name.constructor !== Object){
					this.recordForm.name = name
				 }
				 this.axios.get('/manage/store/recordList',{
				   params:this.recordForm
				 }).then(res=>{
				   if(res.status){
					 this.recordList = res.data.data
					 this.recordForm.total = res.data.total
				   }
				 })
			},
			handleView(row){
				this.$router.push({
				  path:"/store_detail",
				  query: {
					  id:row.id
				  }
				})
			},
			handleOperate(row){
				this.title = '审核'
				this.operate_form.id = row.id
				this.operate_form.status = row.status
				this.operate = true
			},
			handleOperate1(row){
				this.title = '分红模式一'
				this.operate1_form.id = row.id
				this.operate1_form.fh_scale = row.fh_scale
				this.operate1 = true
			},
			handleOperate2(row){
				this.title = '分红模式二'
				this.operate2_form.id = row.id
				this.operate2_form.day = row.day
				this.operate2_form.lj_money = row.lj_money
				this.operate2_form.two_scale = row.two_scale
				this.operate2 = true
			},
			operateSubmit(){
				if(this.operate_form.status == ''){
					this.$message.error('先选择状态')
					return false
				}
				this.axios.post('/manage/'+this.preUrl+'/operate',this.operate_form).then(res=>{
					if(res.status){
						this.$message.success('审核成功')
						this.operate = false
						this.page = 1
						this.getList()
					}else{
						this.$message.error('审核失败')
					}
				})
			},
			operate1Submit(){
				this.$refs.operate1_form.validate(valid => {
				  if (valid) {
					  this.axios.post('/manage/'+this.preUrl+'/toEdit',this.operate1_form).then(res=>{
					  	if(res.status){
					  		this.$message.success('设置成功')
					  		this.operate1 = false
					  		this.page = 1
					  		this.getList()
					  	}else{
					  		this.$message.error('设置失败')
					  	}
					  })
				  }
				})
			},
			operate2Submit(){
				this.$refs.operate2_form.validate(valid => {
				  if (valid) {
					  this.axios.post('/manage/'+this.preUrl+'/toEdit',this.operate2_form).then(res=>{
					  	if(res.status){
					  		this.$message.success('设置成功')
					  		this.operate2 = false
					  		this.page = 1
					  		this.getList()
					  	}else{
					  		this.$message.error('设置失败')
					  	}
					  })
				  }
				})
			},
			getStoreTypes(){
				this.axios.get('/manage/store_type/all').then(res=>{
					if(res.status){
						this.store_types = res.data
					}
				})
			},
			getFhTypes(){
				this.axios.get('/manage/fh_type/all').then(res=>{
					if(res.status){
						this.fh_types = res.data
					}
				})
			},
			reset() {
			  this.form = {
			   name:'',
			   username:'',
			   id_card:'',
			   mobile:'',
			   address:'',
			   sort:100,
			   status:1,
			   avatar:'',
			   url:'',
			   area_id:'',
			   province:"",
			   city:"",
			   country:"",
			   coordinate:'',
			   store_type:'',
			   rz_type:'',
			   fh_type:'',
			   sfz_zm:'',
			   sfz_fm:'',
			   yyzz:'',
			  }
			  this.resetForm('form')
			},
			handleChange() {
				this.province= CodeToText[this.selectedOptions[0]]
				this.city= CodeToText[this.selectedOptions[1]]
				this.country= CodeToText[this.selectedOptions[2]]
				this.form.province = CodeToText[this.selectedOptions[0]]
				this.form.city = CodeToText[this.selectedOptions[1]]
				this.form.country = CodeToText[this.selectedOptions[2]]
				this.form.area_id= this.selectedOptions[2]
			},
			handleEdit(row) {
				this.reset()
				this.open = true
				this.title = '编辑'
				this.form = JSON.parse(JSON.stringify(row))
				this.form.coordinate = this.form.latitude+','+this.form.longitude
				this.selectedOptions = []
				if(this.form.area_ids){
					this.province = this.form.province
					this.city = this.form.city
					this.country = this.form.country
					this.selectedOptions.push(
						TextToCode[this.province].code,
						TextToCode[this.province][this.city].code,
						TextToCode[this.province][this.city][this.country].code
					);
				}
			},
			setMap(data) {
			  this.mapPosition = data.position
			  this.form.coordinate = data.position.join(',')
			  this.form.address = data.address
			  this.mapVisible = false
			},
			uploadSuccess(e){
			   if(e.status){
				 this.form.avatar = e.data.url
				 // this.form.url = e.data.url
			   }
			},
			uploadSuccess1(e){
			   if(e.status){
				 this.form.yyzz = e.data.url
			   }
			},
			uploadSuccess2(e){
			   if(e.status){
				 this.form.sfz_zm = e.data.url
			   }
			},
			uploadSuccess3(e){
			   if(e.status){
				 this.form.sfz_fm = e.data.url
			   }
			},
		}
	}
</script>

<style scoped>

</style>